import { Action } from 'redux';
import { ThunkDispatch } from 'redux-thunk';

import configureStore from './configure';
import { AppState } from './index';

const store = configureStore();

export default store as typeof store & {
  dispatch: ThunkDispatch<AppState, null, Action>;
};
